
export default (googleTagManagerVariables) => {
    const { id } = googleTagManagerVariables;
    const dataLayer = [{
      type_of_page: "Editorial Site",
      came_from_code: 265,
      came_from_value: "news-bandsintown-com-v2",
      // artist_name: name,
      artist_id: id
    }];

    return (
      `<script>
        dataLayer = ${JSON.stringify(dataLayer)}
      </script>
      <!-- Google Tag Manager -->
      <script>(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','GTM-NTHLS8M');</script>
      <!-- End Google Tag Manager -->`
    );
  }